/* Minimal Contact — narrow centered column, hairline-underline inputs,
   no right-side studio panel. Just write. */

import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function MinimalContact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!form.email || !form.message) return;
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Your letter has been received.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="bg-[#FAF9F6] text-[#0E0D0C] min-h-screen pt-32 pb-40 px-6" data-testid="minimal-contact">
      <div className="max-w-lg mx-auto">
        <div className="text-[10px] uppercase tracking-[0.42em] text-[#0E0D0C]/55 mb-16 text-center">
          Write
        </div>
        <form onSubmit={submit} className="space-y-12" data-testid="minimal-contact-form">
          {[
            { name: "name", label: "Your name", type: "text" },
            { name: "email", label: "Email", type: "email" },
          ].map((f) => (
            <div key={f.name}>
              <label className="block text-[10px] uppercase tracking-[0.32em] text-[#0E0D0C]/55 mb-3">
                {f.label}
              </label>
              <input
                type={f.type}
                value={form[f.name]}
                onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
                className="w-full bg-transparent border-0 border-b border-[#0E0D0C]/30 focus:border-[color:var(--tenant-accent)] focus:outline-none py-2 text-base"
                data-testid={`minimal-contact-${f.name}`}
              />
            </div>
          ))}
          <div>
            <label className="block text-[10px] uppercase tracking-[0.32em] text-[#0E0D0C]/55 mb-3">
              Message
            </label>
            <textarea
              rows={5}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full bg-transparent border-0 border-b border-[#0E0D0C]/30 focus:border-[color:var(--tenant-accent)] focus:outline-none py-2 text-base resize-none italic"
              style={{ fontFamily: "var(--tenant-serif)" }}
              data-testid="minimal-contact-message"
            />
          </div>
          <button
            type="submit"
            disabled={sending}
            className="text-[11px] uppercase tracking-[0.32em] pb-1 disabled:opacity-50 hover:opacity-70 transition"
            style={{ borderBottom: "1px solid var(--tenant-accent, #C9A961)" }}
            data-testid="minimal-contact-submit"
          >
            {sending ? "Sending…" : "Send →"}
          </button>
        </form>
      </div>
    </div>
  );
}
